// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JSPqWGsvEj5TOtK1pUNj {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--vnsc-bg-secondary, #111820);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 12px;
}

/* P1-S2: badge ô chart (multi follow-active) — hàng slim trong panel. */
.qgKmuBVVCSNSJxsH1axI {
  display: flex;
  align-items: center;
  padding: 2px 12px 0;
  flex-shrink: 0;
}

.xbSqEdUhgjl_rvRQpnob {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--vnsc-text-primary, #e0e0e0);
}

.zgBlgQbDr2_cmD4mqeHy {
  color: var(--vnsc-color-bullish, #26a69a);
  font-size: 9px;
}

.ciYuy6WxtCwvx1HKgBMB {
  color: var(--vnsc-text-secondary, #727f8c);
  font-weight: 400;
}

/* ── Tầng 1: KPI Header Bar ────────────────────────────────────────── */
.OUpJBqS3RlWUvNhgFia0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 6px 14px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  overflow-x: auto;
  scrollbar-width: none;
  min-height: 52px;
}

.OUpJBqS3RlWUvNhgFia0::-webkit-scrollbar {
  display: none;
}

.s3OWVLeFV8RQsXeC38LH {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.F2buJpcJ62tqbwA4l2VN {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-right: 6px;
  border-right: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));
}

.OqkjH6RpFXjb6Kaw60rh {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--vnsc-color-bullish, #16a34a);
  box-shadow: 0 0 6px rgba(22, 163, 74, 0.4);
  flex: none;
}

.qbvg9F8XAnYofT6SXmEt {
  font-weight: 700;
  font-size: 12px;
  color: var(--vnsc-text-primary, #f1f5f9);
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.mgPKpXUEonWUwci8w8GW {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--vnsc-bg-surface, rgba(255, 255, 255, 0.06));
  color: var(--vnsc-text-secondary, #94a3b8);
  border: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));
}

.VuYMHYjB5asqe_5lHH0z {
  display: flex;
  align-items: stretch;
  gap: 10px;
  min-width: 0;
}

.u7h2Gs9DmG64FvXURAaQ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 6px;
  background: var(--vnsc-bg-primary, #0d141b);
  border: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.06));
  min-width: max-content;
}

.IAHRQMGKSiaIZDy0A6d3 {
  background: var(--vnsc-bg-primary, #0d141b);
  border-color: var(--vnsc-border, #2a2a2a);
}

.kwSEWixEUHmeOLWnwkrT {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

/* Compact KPI reflow: value + pill share one row, meta stacks. */
.DTb8b2l3RoLkF3Kj0gUH {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.cpDfFrMRxtJD7aUdmKKi {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

/* 3-row KPI blocks: row1 pairs, row2 sub-labels, row3 sub-values. */
.uZm7GpsY4IDuz_MOdtvY,
.JBEJpqtaTDUdlylwmWIC {
  display: grid;
  column-gap: 12px;
  row-gap: 1px;
  align-items: center;
  align-content: center;
}

.uZm7GpsY4IDuz_MOdtvY {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.JBEJpqtaTDUdlylwmWIC {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}

.JBEJpqtaTDUdlylwmWIC > .WYHj46HWEJaz5atVWvqg {
  grid-column: 1 / -1;
}

.WYHj46HWEJaz5atVWvqg {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  white-space: nowrap;
}

/* Row 1 hero numbers read larger than rows 2–3 meta. */
.uZm7GpsY4IDuz_MOdtvY ._JKzye_O1EvkJ7akFV70,
.JBEJpqtaTDUdlylwmWIC ._JKzye_O1EvkJ7akFV70 {
  font-size: 15px;
}

.pzCsnqb0hZ4wNA0_VKux {
  font-size: 10px;
  font-weight: 400;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MgLAT5LP1004pw22Or80 {
  font-size: 11px;
  font-weight: 400;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.YYKz8PzVANmFZuV6GIQD {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
}

._JKzye_O1EvkJ7akFV70 {
  font-size: 13px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #ffffff);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.sYcvqLImLEVkudDeXux3 {
  font-size: 14px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #ffffff);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

._6BbQRur83XhegB9LsGA {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;
  color: var(--vnsc-text-secondary, #94a3b8);
  font-variant-numeric: tabular-nums;
  margin-top: 1px;
  white-space: nowrap;
}

/* Currency code suffix on KPI values (VND/USDT — codes need no i18n). */
.MTls6YmgSN6UhP6ukWo_ {
  font-size: 0.62em;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #94a3b8);
  letter-spacing: 0.03em;
}

.xxmeRosyOoKYi0ZMt0qQ {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  color: var(--vnsc-color-bullish, #26a69a);
  background: rgba(38, 166, 154, 0.14);
  border: 1px solid rgba(38, 166, 154, 0.25);
  font-variant-numeric: tabular-nums;
}

.dPnOhFW9AvUWCgiHEz1r {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  color: var(--vnsc-color-bearish, #ef5350);
  background: rgba(239, 83, 80, 0.14);
  border: 1px solid rgba(239, 83, 80, 0.25);
  font-variant-numeric: tabular-nums;
}

.HyQFeO56YEMNtHBER2G6 {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #94a3b8);
  background: rgba(255, 255, 255, 0.05);
  font-variant-numeric: tabular-nums;
}

.Hqcft8vhgES_rPeWPVdO {
  font-size: 10px;
  font-weight: 600;
  padding: 0 4px;
  border-radius: 3px;
  color: var(--vnsc-color-bullish, #26a69a);
  background: rgba(38, 166, 154, 0.12);
}

.a1kzYFBz10aU_JV42BzZ {
  font-size: 10px;
  font-weight: 600;
  padding: 0 4px;
  border-radius: 3px;
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.12);
}

.nM_X5hmqeWlsRMyPocrg {
  font-size: 10px;
  font-weight: 600;
  padding: 0 4px;
  border-radius: 3px;
  color: var(--vnsc-color-bearish, #ef5350);
  background: rgba(239, 83, 80, 0.12);
}

.nnKs8UpwnN254EvSqcCn {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.IxDtozWoVnI7sizekSEe {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0d141b);
  color: var(--vnsc-text-primary, #e0e0e0);
  transition: all 0.15s ease;
  white-space: nowrap;
}

.IxDtozWoVnI7sizekSEe:hover {
  background: var(--vnsc-bg-surface, rgba(255, 255, 255, 0.08));
  border-color: var(--vnsc-border-subtle, rgba(255, 255, 255, 0.15));
}

.qUsq3TgTZVkBHwpIj3vw {
  color: var(--vnsc-text-secondary, #94a3b8);
}

.qUsq3TgTZVkBHwpIj3vw:hover {
  color: var(--vnsc-color-bearish, #ef5350);
  border-color: rgba(239, 83, 80, 0.3);
}

.qUsq3TgTZVkBHwpIj3vw:focus-visible,
.IxDtozWoVnI7sizekSEe:focus-visible {
  outline: 2px solid var(--vnsc-accent, #2f6df6);
  outline-offset: 1px;
}

.qUsq3TgTZVkBHwpIj3vw:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  color: var(--vnsc-text-secondary, #94a3b8);
  border-color: var(--vnsc-border, #2a2a2a);
}

/* Icon-only header actions (labels live in title/aria). */
.DhuzlofV3fOTDLM0Ft7w {
  padding: 0;
  width: 28px;
  justify-content: center;
}

/* ── Tầng 2: Tab Bar ───────────────────────────────────────────────── */
.zgjF9TlUay_M2Yfxi2Zm {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 12px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  min-height: 36px;
}

.ylAUZ77MwOYKf1M91Upw,
.x8PA2avwpd_3C6WZjx0c {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  font-size: 12px;
}

.ylAUZ77MwOYKf1M91Upw {
  color: var(--vnsc-text-secondary, #787b86);
  border-bottom: 2px solid transparent;
  font-weight: 500;
}

.ylAUZ77MwOYKf1M91Upw:hover {
  color: var(--vnsc-text-primary, #e0e0e0);
}

.x8PA2avwpd_3C6WZjx0c {
  color: var(--vnsc-text-primary, #ffffff);
  border-bottom: 2px solid var(--vnsc-accent, #2962ff);
  font-weight: 600;
}

.KshKfN9jgvpITZTDxEtu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  background: rgba(41, 98, 255, 0.15);
  color: var(--vnsc-accent, #2962ff);
}

.uycT2kee0Bvw_8kEghwU {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 13px;
}

.uycT2kee0Bvw_8kEghwU:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary, #ffffff);
}

/* ── Tầng 3: Data Canvas & Empty State ─────────────────────────────── */
.iv9dC2WU5dh9YF3PrUkp {
  flex: 1;
  min-height: 120px;
  overflow: auto;
  padding: 8px 12px;
}

.jHa2rS0_xvEeCi_5H2Cm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 16px;
  text-align: center;
  color: var(--vnsc-text-secondary, #787b86);
}

.FGGQExext0MNydnmbAC2 {
  font-size: 28px;
  margin-bottom: 8px;
  opacity: 0.6;
}

.oJVWX5OVwzmV0JIIUbce {
  font-size: 13px;
  font-weight: 600;
  color: var(--vnsc-text-primary, #e0e0e0);
  margin-bottom: 4px;
}

.DToGTDQje3UKpliBuT6m {
  font-size: 11px;
  color: var(--vnsc-text-secondary, #787b86);
  max-width: 340px;
  line-height: 1.4;
}

.cOMQcZ_ILcRGcpT0Ou7C {
  width: 100%;
  border-collapse: collapse;
}

.cOMQcZ_ILcRGcpT0Ou7C th,
.cOMQcZ_ILcRGcpT0Ou7C td {
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  white-space: nowrap;
}

.cOMQcZ_ILcRGcpT0Ou7C th {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--vnsc-text-secondary, #787b86);
  background: var(--vnsc-bg-secondary, #111820);
  position: sticky;
  top: 0;
  z-index: 1;
}

.cOMQcZ_ILcRGcpT0Ou7C td {
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.04));
}

.cOMQcZ_ILcRGcpT0Ou7C tr:hover td {
  background: rgba(255, 255, 255, 0.02);
}

.cOMQcZ_ILcRGcpT0Ou7C button {
  margin-right: 4px;
  cursor: pointer;
}

.qOC0f2Ji3yTwv4Px1UBi {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.ETaQzg9EBTSE31lw9PLG {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-variant-numeric: tabular-nums;
}

/* ── Tầng 3: Disabled CTA (chuẩn theme công nghiệp, thay nút native) ── */
.uMG2vapnYF_zSvPmerPC {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 14px 16px;
}

.x5Mtae5ruT1HacnABfG5 {
  font-size: 13px;
  font-weight: 600;
  color: var(--vnsc-text-primary, #f1f5f9);
}

._5PGQKnt4t5RB6VXQGBx {
  font-size: 12px;
  color: var(--vnsc-text-secondary, #94a3b8);
}

.bnHZUWstfvMrTg6jBZow {
  margin-top: 4px;
  background: var(--vnsc-accent, #38bdf8);
  border: 1px solid var(--vnsc-accent, #38bdf8);
  color: #0b1220;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
  white-space: nowrap;
}

.bnHZUWstfvMrTg6jBZow:hover {
  filter: brightness(1.1);
}

/* ── Dialog nạp vốn paper (thay ConfirmDialog reset) ── */
.ODuaQbMt0AQ8fRNKoOxi {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(4, 8, 16, 0.6);
  z-index: 20;
}

.Q0805biRDN9rkC6RryjS {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 280px;
  max-width: 340px;
  padding: 14px 16px;
  background: var(--vnsc-bg-secondary, #131722);
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.16));
  border-radius: 8px;
}

.ep1Tn_r7OJSJ7hF1iUsh {
  font-size: 13px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #f1f5f9);
}

.Eq1lmNUsVR4KCppX5uPC {
  font-size: 12px;
  color: var(--vnsc-text-secondary, #94a3b8);
}

.qhbiuNhmNAjeYG9rO_y8 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.CtfTdX9UY2HsXb9NUsg2 {
  background: transparent;
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.25));
  color: var(--vnsc-text-secondary, #94a3b8);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.CtfTdX9UY2HsXb9NUsg2:hover {
  border-color: var(--vnsc-accent, #38bdf8);
  color: var(--vnsc-accent, #38bdf8);
}

.YLZ5LfbgpvZfZj6RPC1x {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #94a3b8);
}

.YLZ5LfbgpvZfZj6RPC1x input {
  background: var(--vnsc-bg-primary, #0b1220);
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.25));
  color: var(--vnsc-text-primary, #f1f5f9);
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
}

.ykT2OvYOXnLC0FBHk7Hg {
  font-size: 12px;
  color: var(--vnsc-color-bearish, #ef5350);
}

.SUeeBbWwZhWfDnaqezVt {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.SUeeBbWwZhWfDnaqezVt button {
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.SUeeBbWwZhWfDnaqezVt button[data-testid="capital-confirm"] {
  background: var(--vnsc-accent, #38bdf8);
  border: 1px solid var(--vnsc-accent, #38bdf8);
  color: #0b1220;
}

.SUeeBbWwZhWfDnaqezVt button[data-testid="capital-confirm"]:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.SUeeBbWwZhWfDnaqezVt button[data-testid="capital-cancel"] {
  background: transparent;
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.25));
  color: var(--vnsc-text-secondary, #94a3b8);
}

`, "",{"version":3,"sources":["webpack://./src/widget/trading/panel/TradingBottomPanel.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,wCAAwC;EACxC,gGAAgG;EAChG,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,oDAAoD;EACpD,6CAA6C;EAC7C,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;EAC7D,0CAA0C;EAC1C,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,sEAAsE;EACtE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,oEAAoE;AACpE;;EAEE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,2CAA2C;EAC3C,wCAAwC;EACxC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,kEAAkE;AACpE;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;;EAEE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oDAAoD;EACpD,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA,yEAAyE;AACzE;EACE,OAAO;EACP,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,6EAA6E;AAC/E;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;AACpC;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,6CAA6C;EAC7C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,+DAA+D;EAC/D,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,0CAA0C;AAC5C","sourcesContent":[".panel {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n  font-size: 12px;\r\n}\r\n\r\n/* P1-S2: badge ô chart (multi follow-active) — hàng slim trong panel. */\r\n.titleBadgeRow {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 2px 12px 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.titleBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.titleBadgeDot {\r\n  color: var(--vnsc-color-bullish, #26a69a);\r\n  font-size: 9px;\r\n}\r\n\r\n.titleBadgeId {\r\n  color: var(--vnsc-text-secondary, #727f8c);\r\n  font-weight: 400;\r\n}\r\n\r\n/* ── Tầng 1: KPI Header Bar ────────────────────────────────────────── */\r\n.panelHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding: 6px 14px;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n  min-height: 52px;\r\n}\r\n\r\n.panelHeader::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.headerLeft {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.brandSection {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n  padding-right: 6px;\r\n  border-right: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.statusDot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: var(--vnsc-color-bullish, #16a34a);\r\n  box-shadow: 0 0 6px rgba(22, 163, 74, 0.4);\r\n  flex: none;\r\n}\r\n\r\n.brandTitle {\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-primary, #f1f5f9);\r\n  letter-spacing: 0.01em;\r\n  white-space: nowrap;\r\n}\r\n\r\n.brandBadge {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  background: var(--vnsc-bg-surface, rgba(255, 255, 255, 0.06));\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  border: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.kpiGrid {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 10px;\r\n  min-width: 0;\r\n}\r\n\r\n.kpiCard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-primary, #0d141b);\r\n  border: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.06));\r\n  min-width: max-content;\r\n}\r\n\r\n.kpiCardPrimary {\r\n  background: var(--vnsc-bg-primary, #0d141b);\r\n  border-color: var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.kpiCardRow {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n}\r\n\r\n/* Compact KPI reflow: value + pill share one row, meta stacks. */\r\n.kpiValueRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.kpiStack {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n\r\n/* 3-row KPI blocks: row1 pairs, row2 sub-labels, row3 sub-values. */\r\n.kpiWide,\r\n.kpiWide3 {\r\n  display: grid;\r\n  column-gap: 12px;\r\n  row-gap: 1px;\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n\r\n.kpiWide {\r\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\r\n}\r\n\r\n.kpiWide3 {\r\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\r\n}\r\n\r\n.kpiWide3 > .kpiPair {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.kpiPair {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  min-width: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Row 1 hero numbers read larger than rows 2–3 meta. */\r\n.kpiWide .kpiValue,\r\n.kpiWide3 .kpiValue {\r\n  font-size: 15px;\r\n}\r\n\r\n.kpiSubLabel {\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.kpiSubVal {\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.kpiLabel {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n}\r\n\r\n.kpiValue {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-text-primary, #ffffff);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n}\r\n\r\n.kpiValueLarge {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-text-primary, #ffffff);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n}\r\n\r\n.kpiSub {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  font-variant-numeric: tabular-nums;\r\n  margin-top: 1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Currency code suffix on KPI values (VND/USDT — codes need no i18n). */\r\n.kpiCur {\r\n  font-size: 0.62em;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.pnlPillPositive {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-color-bullish, #26a69a);\r\n  background: rgba(38, 166, 154, 0.14);\r\n  border: 1px solid rgba(38, 166, 154, 0.25);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.pnlPillNegative {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-color-bearish, #ef5350);\r\n  background: rgba(239, 83, 80, 0.14);\r\n  border: 1px solid rgba(239, 83, 80, 0.25);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.pnlPillNeutral {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  background: rgba(255, 255, 255, 0.05);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.marginBadgeSafe {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 0 4px;\r\n  border-radius: 3px;\r\n  color: var(--vnsc-color-bullish, #26a69a);\r\n  background: rgba(38, 166, 154, 0.12);\r\n}\r\n\r\n.marginBadgeWarning {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 0 4px;\r\n  border-radius: 3px;\r\n  color: #f59e0b;\r\n  background: rgba(245, 158, 11, 0.12);\r\n}\r\n\r\n.marginBadgeDanger {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 0 4px;\r\n  border-radius: 3px;\r\n  color: var(--vnsc-color-bearish, #ef5350);\r\n  background: rgba(239, 83, 80, 0.12);\r\n}\r\n\r\n.headerActions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n  margin-left: auto;\r\n}\r\n\r\n.btnAction {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  height: 28px;\r\n  padding: 0 10px;\r\n  border-radius: 5px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-primary, #0d141b);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btnAction:hover {\r\n  background: var(--vnsc-bg-surface, rgba(255, 255, 255, 0.08));\r\n  border-color: var(--vnsc-border-subtle, rgba(255, 255, 255, 0.15));\r\n}\r\n\r\n.btnReset {\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n.btnReset:hover {\r\n  color: var(--vnsc-color-bearish, #ef5350);\r\n  border-color: rgba(239, 83, 80, 0.3);\r\n}\r\n\r\n.btnReset:focus-visible,\r\n.btnAction:focus-visible {\r\n  outline: 2px solid var(--vnsc-accent, #2f6df6);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.btnReset:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  border-color: var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n/* Icon-only header actions (labels live in title/aria). */\r\n.btnIconOnly {\r\n  padding: 0;\r\n  width: 28px;\r\n  justify-content: center;\r\n}\r\n\r\n/* ── Tầng 2: Tab Bar ───────────────────────────────────────────────── */\r\n.tabBar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  padding: 0 12px;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  min-height: 36px;\r\n}\r\n\r\n.tab,\r\n.activeTab {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n}\r\n\r\n.tab {\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  border-bottom: 2px solid transparent;\r\n  font-weight: 500;\r\n}\r\n\r\n.tab:hover {\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.activeTab {\r\n  color: var(--vnsc-text-primary, #ffffff);\r\n  border-bottom: 2px solid var(--vnsc-accent, #2962ff);\r\n  font-weight: 600;\r\n}\r\n\r\n.tabBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 16px;\r\n  height: 16px;\r\n  padding: 0 4px;\r\n  border-radius: 999px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  background: rgba(41, 98, 255, 0.15);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.btnClosePinned {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  font-size: 13px;\r\n}\r\n\r\n.btnClosePinned:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: var(--vnsc-text-primary, #ffffff);\r\n}\r\n\r\n/* ── Tầng 3: Data Canvas & Empty State ─────────────────────────────── */\r\n.tabBody {\r\n  flex: 1;\r\n  min-height: 120px;\r\n  overflow: auto;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.emptyContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 36px 16px;\r\n  text-align: center;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.emptyIcon {\r\n  font-size: 28px;\r\n  margin-bottom: 8px;\r\n  opacity: 0.6;\r\n}\r\n\r\n.emptyTitle {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.emptyHint {\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  max-width: 340px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  text-align: left;\r\n  padding: 6px 10px;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  white-space: nowrap;\r\n}\r\n\r\n.table th {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.table td {\r\n  font-variant-numeric: tabular-nums;\r\n  border-bottom: 1px solid var(--vnsc-border-subtle, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.table tr:hover td {\r\n  background: rgba(255, 255, 255, 0.02);\r\n}\r\n\r\n.table button {\r\n  margin-right: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.kpis {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.logList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* ── Tầng 3: Disabled CTA (chuẩn theme công nghiệp, thay nút native) ── */\r\n.ctaContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  padding: 14px 16px;\r\n}\r\n\r\n.ctaTitle {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary, #f1f5f9);\r\n}\r\n\r\n.ctaHint {\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n.ctaButton {\r\n  margin-top: 4px;\r\n  background: var(--vnsc-accent, #38bdf8);\r\n  border: 1px solid var(--vnsc-accent, #38bdf8);\r\n  color: #0b1220;\r\n  padding: 6px 14px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: filter 0.15s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ctaButton:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n/* ── Dialog nạp vốn paper (thay ConfirmDialog reset) ── */\r\n.capitalOverlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(4, 8, 16, 0.6);\r\n  z-index: 20;\r\n}\r\n\r\n.capitalBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  min-width: 280px;\r\n  max-width: 340px;\r\n  padding: 14px 16px;\r\n  background: var(--vnsc-bg-secondary, #131722);\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.16));\r\n  border-radius: 8px;\r\n}\r\n\r\n.capitalTitle {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-text-primary, #f1f5f9);\r\n}\r\n\r\n.capitalHint {\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n.capitalPresets {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n.capitalPreset {\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.25));\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  padding: 4px 10px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.capitalPreset:hover {\r\n  border-color: var(--vnsc-accent, #38bdf8);\r\n  color: var(--vnsc-accent, #38bdf8);\r\n}\r\n\r\n.capitalField {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n.capitalField input {\r\n  background: var(--vnsc-bg-primary, #0b1220);\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.25));\r\n  color: var(--vnsc-text-primary, #f1f5f9);\r\n  padding: 6px 10px;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n}\r\n\r\n.capitalError {\r\n  font-size: 12px;\r\n  color: var(--vnsc-color-bearish, #ef5350);\r\n}\r\n\r\n.capitalActions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n\r\n.capitalActions button {\r\n  padding: 6px 14px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.capitalActions button[data-testid=\"capital-confirm\"] {\r\n  background: var(--vnsc-accent, #38bdf8);\r\n  border: 1px solid var(--vnsc-accent, #38bdf8);\r\n  color: #0b1220;\r\n}\r\n\r\n.capitalActions button[data-testid=\"capital-confirm\"]:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.capitalActions button[data-testid=\"capital-cancel\"] {\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.25));\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `JSPqWGsvEj5TOtK1pUNj`,
	"titleBadgeRow": `qgKmuBVVCSNSJxsH1axI`,
	"titleBadge": `xbSqEdUhgjl_rvRQpnob`,
	"titleBadgeDot": `zgBlgQbDr2_cmD4mqeHy`,
	"titleBadgeId": `ciYuy6WxtCwvx1HKgBMB`,
	"panelHeader": `OUpJBqS3RlWUvNhgFia0`,
	"headerLeft": `s3OWVLeFV8RQsXeC38LH`,
	"brandSection": `F2buJpcJ62tqbwA4l2VN`,
	"statusDot": `OqkjH6RpFXjb6Kaw60rh`,
	"brandTitle": `qbvg9F8XAnYofT6SXmEt`,
	"brandBadge": `mgPKpXUEonWUwci8w8GW`,
	"kpiGrid": `VuYMHYjB5asqe_5lHH0z`,
	"kpiCard": `u7h2Gs9DmG64FvXURAaQ`,
	"kpiCardPrimary": `IAHRQMGKSiaIZDy0A6d3`,
	"kpiCardRow": `kwSEWixEUHmeOLWnwkrT`,
	"kpiValueRow": `DTb8b2l3RoLkF3Kj0gUH`,
	"kpiStack": `cpDfFrMRxtJD7aUdmKKi`,
	"kpiWide": `uZm7GpsY4IDuz_MOdtvY`,
	"kpiWide3": `JBEJpqtaTDUdlylwmWIC`,
	"kpiPair": `WYHj46HWEJaz5atVWvqg`,
	"kpiValue": `_JKzye_O1EvkJ7akFV70`,
	"kpiSubLabel": `pzCsnqb0hZ4wNA0_VKux`,
	"kpiSubVal": `MgLAT5LP1004pw22Or80`,
	"kpiLabel": `YYKz8PzVANmFZuV6GIQD`,
	"kpiValueLarge": `sYcvqLImLEVkudDeXux3`,
	"kpiSub": `_6BbQRur83XhegB9LsGA`,
	"kpiCur": `MTls6YmgSN6UhP6ukWo_`,
	"pnlPillPositive": `xxmeRosyOoKYi0ZMt0qQ`,
	"pnlPillNegative": `dPnOhFW9AvUWCgiHEz1r`,
	"pnlPillNeutral": `HyQFeO56YEMNtHBER2G6`,
	"marginBadgeSafe": `Hqcft8vhgES_rPeWPVdO`,
	"marginBadgeWarning": `a1kzYFBz10aU_JV42BzZ`,
	"marginBadgeDanger": `nM_X5hmqeWlsRMyPocrg`,
	"headerActions": `nnKs8UpwnN254EvSqcCn`,
	"btnAction": `IxDtozWoVnI7sizekSEe`,
	"btnReset": `qUsq3TgTZVkBHwpIj3vw`,
	"btnIconOnly": `DhuzlofV3fOTDLM0Ft7w`,
	"tabBar": `zgjF9TlUay_M2Yfxi2Zm`,
	"tab": `ylAUZ77MwOYKf1M91Upw`,
	"activeTab": `x8PA2avwpd_3C6WZjx0c`,
	"tabBadge": `KshKfN9jgvpITZTDxEtu`,
	"btnClosePinned": `uycT2kee0Bvw_8kEghwU`,
	"tabBody": `iv9dC2WU5dh9YF3PrUkp`,
	"emptyContainer": `jHa2rS0_xvEeCi_5H2Cm`,
	"emptyIcon": `FGGQExext0MNydnmbAC2`,
	"emptyTitle": `oJVWX5OVwzmV0JIIUbce`,
	"emptyHint": `DToGTDQje3UKpliBuT6m`,
	"table": `cOMQcZ_ILcRGcpT0Ou7C`,
	"kpis": `qOC0f2Ji3yTwv4Px1UBi`,
	"logList": `ETaQzg9EBTSE31lw9PLG`,
	"ctaContainer": `uMG2vapnYF_zSvPmerPC`,
	"ctaTitle": `x5Mtae5ruT1HacnABfG5`,
	"ctaHint": `_5PGQKnt4t5RB6VXQGBx`,
	"ctaButton": `bnHZUWstfvMrTg6jBZow`,
	"capitalOverlay": `ODuaQbMt0AQ8fRNKoOxi`,
	"capitalBox": `Q0805biRDN9rkC6RryjS`,
	"capitalTitle": `ep1Tn_r7OJSJ7hF1iUsh`,
	"capitalHint": `Eq1lmNUsVR4KCppX5uPC`,
	"capitalPresets": `qhbiuNhmNAjeYG9rO_y8`,
	"capitalPreset": `CtfTdX9UY2HsXb9NUsg2`,
	"capitalField": `YLZ5LfbgpvZfZj6RPC1x`,
	"capitalError": `ykT2OvYOXnLC0FBHk7Hg`,
	"capitalActions": `SUeeBbWwZhWfDnaqezVt`
};
export default ___CSS_LOADER_EXPORT___;
